import React from 'react';

import { useTranslation } from 'react-i18next';
import { Flex, H4, P } from 'design-system-web';
import { WatchlistLevelsPanel } from '../../../../components/WatchlistLevelsPanel/WatchlistLevelsPanel';
import { VisitorConfiguration } from '../../../../types/VisitorConfiguration';
import { WatchlistLevelConfig } from 'graphql-query-contracts';

type Prop = {
  channel: any;
  onConfigUpdated: (update: VisitorConfiguration) => void;
  config: VisitorConfiguration;
  loading?: boolean;
  showValidationErrors?: boolean;
};

export function WatchlistLevelsTab({
  channel,
  onConfigUpdated,
  config,
  loading: _loading,
  showValidationErrors,
}: Prop): JSX.Element {
  const { t } = useTranslation();

  const handleFieldUpdate = (update: WatchlistLevelConfig[]) => {
    onConfigUpdated({
      watchlistLevels: update,
    });
  };

  return (
    <Flex direction="column" gap={5}>
      <Flex direction="column" gap={1}>
        <H4>{t('web.admin.visitorManagement.configuration.tab.watchlistLevels')}</H4>
        <P>{t('web.admin.visitorManagement.configuration.tab.watchlistLevels.description')}</P>
      </Flex>

      <WatchlistLevelsPanel 
        channelId={channel._id} 
        onFieldUpdate={handleFieldUpdate}
        configs={config.watchlistLevels}
        showValidationErrors={showValidationErrors}
      />
    </Flex>
  );
}

